export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00659.aad90e20.png";